<template>
  <div>
    <section class="hero">
      <div class="container">
        <div class="columns is-mobile is-centered">
          <div class="column has-text-centered">
            <h1 class="title is-1 has-text-primary">My Skills</h1>
            <h4 class="subtitle is-4 has-text-primary-invert">focused on bringing ideas to life</h4>
            <div class="container" style="padding: 1rem 0 1rem 0;">
              <a href="https://f002.backblazeb2.com/file/ethanfox-site/EthanFoxResume.pdf" target="_blank">
                <button class="button is-light">Resume</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--<section>
      <div class="container">
        <p class="has-text-centered is-size-5">
          Just want a résumé? No problem.
        </p>
      </div>
    </section> -->
    <section class="section">
      <div class="container skills-container">
        <h1 class="is-1 title has-text-primary">Front-end</h1>
        <!--<p class="is-size-4">In the world we see new iterations of technologies constantly emerging. I read what I can, write about some of it, and truly dig deep into even less. My goal is to find technologies that I think can make me better at what I want to do, <u>bringing ideas to life</u>.</p> -->
        <div class="box">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <h3 class="title is-3"><a href="https://vuejs.org" target="_blank">VueJS</a></h3>
                <p>Learning <a href="https://vuejs.org" target="_blank">Vue</a> has been a treat; it truly succeedes in its core promises of approachability and versatility. Coming from a <a href="https://djangoproject.com" target="_blank">Django</a> background the HTML-based templating, for instance, is comfortable on first-use but I'm never worried about being locked into a tool that's not powerful enough for my needs.</p>
              </div>
            </div>
            <div class="media-right">
              <figure class="image"><img class="image is-128x128" src="https://upload.wikimedia.org/wikipedia/commons/9/95/Vue.js_Logo_2.svg" alt="Image"></figure>
            </div>
          </article>
        </div>
        <div class="box">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <h3 class="title is-3"><a href="https://reactjs.org" target="_blank">ReactJS</a></h3>
                <p><a href="https://reactjs.org" target="_blank">React</a> introduced me to many new, exciting concepts. Coming from the world of <a href="https://angularjs.org" target="_blank">Angular 1's</a> scope and dependency injection React's component-based approach was a breath of fresh air. React also introduced me to Flux, and later Redux, which have helped me better grasp scope in more contexts.</p>
              </div>
            </div>
            <div class="media-right">
              <figure class="image"><img class="image is-128x128" src="https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg" alt="Image"></figure>
            </div>
          </article>
        </div>
        <div class="box">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <h3 class="title is-3"><a href="https://angularjs.org" target="_blank">AngularJS 1</a></h3>
                <p><a href="https://angularjs.org" target="_blank">Angular</a> helped spark my interest in single page progressive web apps. The first time I got two-way data 
                  binding setup over my REST API, so many puzzle pieces started to click together. <a href="https://angularjs.org" target="_blank">Angular</a> was also the first JS framework 
                  I built out a more substantial project in; I learned many lessons that I would later re-use even when working in other frameworks.</p>
              </div>
            </div>
            <div class="media-right">
              <figure class="image"><img class="image is-128x128" src="https://upload.wikimedia.org/wikipedia/commons/c/cf/Angular_full_color_logo.svg" alt="Image"></figure>
            </div>
          </article>
        </div>
        <h1 class="is-1 title has-text-primary">UI / UX</h1>
        <div class="box">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <h3 class="title is-3"><a href="https://affinity.serif.com/en-us/designer/" target="_blank">Affinity Designer</a></h3>
                <p><a href="https://affinity.serif.com/en-us/designer/" target="_blank">Affinity</a> is a fantastic mix of <a href="https://sketchapp.com" target="_blank">Sketch</a>, Illustrator, and Photoshop for a much lower price. The low-cost barrier has made it a go-to for me; as thus-far I have primarily been working on bootstrapped design teams.</p>
              </div>
            </div>
            <div class="media-right">
              <figure class="image"><img class="image is-128x128" src="https://i.pinimg.com/originals/69/aa/5f/69aa5fdcd8b44ac8822bb00702f92d5e.png" alt="Image"></figure>
            </div>
          </article>
        </div>
        <div class="box">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <h3 class="title is-3"><a href="https://sketchapp.com" target="_blank">Sketch</a></h3>
                <p><a href="https://sketchapp.com" target="_blank">Sketch</a> was my first full introduction to vector-based graphical design and I <i>loved</i> it. 
                  <a href="https://sketchapp.com" target="_blank">Sketch</a> is accompanied by a fantastic plugin ecosystem that make even more advanced workflows
                  (such as automatically into <a href="https://invisionapp.com" target="_blank">InVision</a>) possible. With the new update releasing animations and 
                  prototyping, I'm excited to explore the tool even further.</p>
              </div>
            </div>
            <div class="media-right">
              <figure class="image"><img class="image is-128x128" src="https://www.sketch.com/images/pages/press/sketch-press-kit/app-icons/sketch-mac-icon@2x.png" alt="Image"></figure>
            </div>
          </article>
        </div>
        <div class="box">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <h3 class="title is-3"><a href="https://adobe.com/creativecloud" target="_blank">Adobe CC</a></h3>
                <p>The thing that really attracted me was the unified set of tooling. Anything you want to work on from photo to video is covered in a very holistic fashion.
                  I also wanted to learn CC because, in my mind, it is one of the definitions of "Industry standard". While some are attempting to distrupt that (see above),
                  the years of dominance is still felt and everyone is trying to achieve parity with their feature set. With a solid grasp of Photoshop, Illustrator, After Effects, etc. I could
                  do most anything my mind desired.</p>
              </div>
            </div>
            <div class="media-right">
              <figure class="image"><img class="image is-128x128" src="https://upload.wikimedia.org/wikipedia/en/c/c1/Adobe_Creative_Cloud_CC_icon.svg" alt="Image"></figure>
            </div>
          </article>
        </div>
        <h1 class="is-1 title has-text-primary">Back-end</h1>
        <div class="box">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <h3 class="title is-3"><a href="https://djangoproject.com" target="_blank">Django</a> / <a href="http://django-rest-framework.org" target="_blank">Django Rest Framework</a></h3>
                <p>I wrote my first interactive web apps in <a href="https://djangoproject.com" target="_blank">Django</a>. It took a while, but slowly the pieces of MVC (MVT) came together and gave me the building blocks to create a lot of cool stuff.
                  Now my use of <a href="https://djangoproject.com" target="_blank">Django</a> has mostly moved to more barebones <a href="http://django-rest-framework.org" target="_blank">DRF</a> applications to serve data to/from my database to my PWA.</p>
              </div>
            </div>
            <div class="media-right">
              <figure class="image"><img class="image is-128x128" src="https://cdn.worldvectorlogo.com/logos/django.svg" alt="Image"></figure>
            </div>
          </article>
        </div>
        <div class="box">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <h3 class="title is-3"><a href="https://python.org" target="_blank">Python</a></h3>
                <p>I try to do most of my work in <a href="https://python.org" target="_blank">Python</a>. Why? The syntax is easy to read which helps with larger codebases, the community is fantastic, and it is plenty fast for 99% of my use-cases. When it isn't I fall back to <a href="https://golang.org" target="_blank">Go</a> or <a href="https://rust-lang.org" target="_blank">Rust</a>.</p>
              </div>
            </div>
            <div class="media-right">
              <figure class="image"><img class="image is-128x128" src="https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg" alt="Image"></figure>
            </div>
          </article>
        </div>
        <h1 class="is-1 title has-text-primary">Linux / DevOps</h1>
        <div class="box">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <h3 class="title is-3"><a href="https://saltstack.com" target="_blank">SaltStack</a></h3>
                <p>When getting more serious about maintaining application clusters at scale I knew I needed a tool to facilitate my needs. I checked out <a href="https://chef.io">Chef</a>, <a href="https://puppet.com">Puppet</a>, <a href="https://ansible.com">Ansible</a>, and <a href="https://saltstack.com" target="_blank">SaltStack</a>.
                  After some deliberation I decided I wanted to stay in the Python world, so it came down to <a href="https://ansible.com">Ansible</a> and <a href="https://saltstack.com" target="_blank">Salt</a>. In the end I chose <a href="https://saltstack.com" target="_blank">Salt</a> due to the added flexibility of the client running on each machine. Ansible's ease of being able to just point at a box is nice but I wanted to learn a more flexible, robust tool first. Salt hasn't disappointed.</p> 
              </div>
            </div>
            <div class="media-right">
              <figure class="image"><img class="image is-128x128" src="https://seeklogo.com/images/S/saltstack-logo-71FB5007CA-seeklogo.com.png" alt="Image"></figure>
            </div>
          </article>
        </div>
        <div class="box">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <h3 class="title is-3"><a href="https://debian.org" target="_blank">Debian</a> / <a href="https://ubuntu.com" target="_blank">Ubuntu</a></h3>
                <p>I really enjoy <a href="https://debian.org" target="_blank">Debian</a>-based distros. Perhaps it is because I started with <a href="https://debian.org" target="_blank">Debian</a> when my friend's older brother Cory introduced me to Linux, or perhaps it's due to <a href="https://digitalocean.com" target="_blank">DigitalOcean</a> making <a href="https://ubuntu.com" target="_blank">Ubuntu</a> the default image on their Cloud giving me a lot of direct experience with it on Platform Support. 
                  I tend to have to Google around less when working in <a href="https://ubuntu.com" target="_blank">Ubuntu</a>/<a href="https://debian.org" target="_blank">Debian</a>, and I hope I continue to get to use other wonderful derivatives (I am writing this from <a href="https://elementary.io">ElementaryOS</a> in a VM on my Windows 10 Desktop).</p> 
              </div>
            </div>
            <div class="media-right">
              <figure class="image"><img class="image is-128x128" src="https://upload.wikimedia.org/wikipedia/commons/6/66/Openlogo-debianV2.svg" alt="Image"></figure>
            </div>
          </article>
        </div>
        <div class="box">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <h3 class="title is-3"><a href="https://centos.org" target="_blank">CentOS</a> / <a href="https://www.redhat.com/en/technologies/linux-platforms/enterprise-linux" target="_blank">RHEL</a></h3>
                <p>Though I've spent less time in <a href="https://centos.org" target="_blank">CentOS</a> and <a href="https://www.redhat.com/en/technologies/linux-platforms/enterprise-linux" target="_blank">RHEL</a> I do have an appreciation for them. I setup and ran a personal filesharing, game, and <a href="https://teamspeak.com" target="_blank">TeamSpeak</a> server in my room (on recycled hardware and a tax to my mother's energy bill) for years on <a href="https://centos.org" target="_blank">CentOS</a> to learn basic management. I came into more use-cases through my work at <a href="https://digitalocean.com" target="_blank">DigitalOcean</a>.</p> 
              </div>
            </div>
            <div class="media-right">
              <figure class="image"><img class="image is-128x128" src="https://seeklogo.com/images/C/CentOS-logo-61929B91AB-seeklogo.com.png" alt="Image"></figure>
            </div>
          </article>
        </div>
        <h1 class="is-1 title has-text-primary">Project management / Business development</h1>
        <div class="box">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <h3 class="title is-3"><a href="https://scrum.org" target="_blank">Scrum</a> / <a href="https://en.wikipedia.org/wiki/Kanban_(development)" target="_blank">Kanban</a> / <a href="https://en.wikipedia.org/wiki/Agile_software_development" target="_blank">Agile</a></h3>
                <p>I originally got into <a href="https://scrum.org" target="_blank">Scrum</a> by reading <a href="https://www.amazon.com/Scrum-Doing-Twice-Work-Half/dp/038534645X" target="_blank"><i><b>SCRUM</b> The Art of Doing Twice the Work in Half the Time</i></a> by Jeff and J.J Sutherland.
                  I was just getting into project management and was delving into tools like Atlassian's Suite (<a href="https://www.atlassian.com/software/jira" target="_blank">JIRA</a>, 
                  <a href="https://www.atlassian.com/software/confluence" target="_blank">Confluence</a>, and now <a href="https://trello.com" target="_blank">Trello</a>). 
                  I needed a way to structure my thoughts and this book was a perfect outlet. Since then, I've expanded on those ideas with books like <a href="https://www.amazon.com/Lean-Product-Playbook-Innovate-Products/dp/1118960874" target="_blank"><i>The Lean Product Playbook</i></a> by Dan Olsen. tl;dr: I'm a big fan of rapid iteration and building MVPs that achieve market-fit.</p>
              </div>
            </div>
            <div class="media-right">
              <figure class="image"><font-awesome-icon style="font-size: 128px;" icon="recycle"/></figure>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
export default {
  data: function () {
    return {
      title: 'Skills'
    }
  },
  // Usage with context the component
  head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function () {
      return {
        inner: this.title
      }
    },
    meta: [
      { name: 'description', content: 'The homebase for all my thoughts', id: 'desc' }
    ]
  }
}
</script>

<style lang="scss" scoped>
.media {
align-items: center;
}
.container{
  padding-top: 5vh;
}
.skills-container{
  padding-top: 0;
}
h4 {
  border-bottom: solid 3px #FFAB91;
  display: inline;
  padding-bottom:4px;
  line-height: 200%;
}
footer a {
  color: #F44336;
}
</style>
